// Synthetic, Semi-Synthetic, Conventional.
export const formulationOptions: any[] = [
  { name: 'Full Synthetic', value: 'Full Synthetic' },
  { name: 'Synthetic Blend', value: 'Synthetic Blend' },
  { name: 'Conventional', value: 'Conventional' },
];
export const viscosityOptions: any[] = [
  { name: '0W-16', value: '0W-16' },
  { name: '0W-20', value: '0W-20' },
  { name: '0W-30', value: '0W-30' },
  { name: '0W-40', value: '0W-40' },
  { name: '5W-20', value: '5W-20' },
  { name: '5W-30', value: '5W-30' },
  { name: '5W-40', value: '5W-40' },
  { name: '5W-50', value: '5W-50' },
  { name: '10W-30', value: '10W-30' },
  { name: '10W-40', value: '10W-40' },
  { name: '15W-40', value: '15W-40' },
  { name: '20W-50', value: '20W-50' },
];
export const measureOptions: any = [
  { name: 'Quarts', value: 'Quart' },
  { name: 'Litres', value: 'Litre' },
];

export function reorderOptions(options: any[], matchValue: string) {
  return options.sort((a, b) => {
    if (a.name === matchValue) return -1;
    if (b.name === matchValue) return 1;
    return 0;
  });
}
